import { Box } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AppTopBar from "../base-app/AppTopBar";
import ProfileMyTools from "./ProfileMyTools";
import BottomBar from "components/base-app/BottomBar";
import LogOutButton from "../login/LogOutButton";
import { AppContainerWithBottomBar } from "components/base-app/AppWithBottomBar";

const ProfilePage = () => {
  return (
    <>
      <AppTopBar
        icon={<AccountCircleIcon color="primary" />}
        title={"Your Forest"}
      />
      <AppContainerWithBottomBar>
        <ProfileMyTools />

        <Box flexGrow={1} />
        <Box margin="auto" mt={1}>
          <LogOutButton />
        </Box>
      </AppContainerWithBottomBar>
      <BottomBar />
    </>
  );
};

export default ProfilePage;
